export default __webpack_public_path__ + "static/media/swap.3d1660b9.svg";